import { render, staticRenderFns } from "./Satuan.vue?vue&type=template&id=10df0c00"
import script from "./Satuan.vue?vue&type=script&lang=js"
export * from "./Satuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports